<div class="position-container">
  <div class="player-img" [style]="getBgr()" *ngIf="player.imageSrc && player.imageSrc != 'https://static.wbsc.org/assets/images/default-player.jpg' && !flipped && !skipPortraits"></div>
  <div class="player-title">
    <div class="position" [style.background-color]="bgColor">
      {{utilService.positionToString(player.position)}}
    </div>
    <div class="name">
      {{player.name.toUpperCase()}}
    </div>
  </div>
  <div class="player-img" [style]="getBgr()" *ngIf="player.imageSrc && player.imageSrc != 'https://static.wbsc.org/assets/images/default-player.jpg' && flipped && !skipPortraits"></div>
</div>
